(ns entities.priorities.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.priorities.specs :as sp]
    )
  )

(def path [:entities :priorities])

(rf/reg-entity
  :priorities
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/priorities)
                :success [:priorities/fetched]
                :error [:priorities/fetch-errored]
                :cancellable? true}})

   :patch
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/update-priorities {:input data})
                :success [:priorities/updated]
                :error [:priorities/update-errored]}})

   :spec/patch ::sp/patch
   })

(rf/reg-event-db
  :priorities/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :priorities])))

(rf/reg-event-db
  :priorities/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :priorities])))

(rf/reg-event-db
  :priorities/updated
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:update-priorities])))

(rf/reg-event-db
  :priorities/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:update-priorities])))
